import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { XTMAssistant } from './XTMAssistantWrapper';



// Export for UMD build
declare global {
  interface Window {
    XTMAssistant: typeof XTMAssistant;
  }
}

window.XTMAssistant = XTMAssistant;

// Only mount the app if we're in the main app context (not when injected)
const rootElement = document.getElementById('ai-assistant-container');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}










